export const formatIDR = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(Number(n || 0));

export const unitPrice = (p, qty = 1) => {
  let price = p.promo_price ?? p.price;
  const tiers = [...(p.grosir_tiers || [])].sort((a, b) => b.min_qty - a.min_qty);
  const t = tiers.find((x) => qty >= x.min_qty);
  if (t) price = Math.round(price * (1 - t.percent / 100));
  return price;
};

export const formatDateID = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", {
      day: "2-digit", month: "short", year: "numeric",
      timeZone: "Asia/Jakarta",
    });
  } catch {
    return iso;
  }
};

export const formatTimeID = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleTimeString("id-ID", {
      hour: "2-digit", minute: "2-digit", timeZone: "Asia/Jakarta",
    });
  } catch { return iso; }
};

export const roleLabels = {
  owner: "Owner",
  hr: "HR / Admin",
  supervisor: "Supervisor",
  kasir: "Kasir",
  crew: "Crew Store",
  gudang: "Gudang",
  logistik: "Admin Logistik",
  host_live: "Host Live",
  karyawan: "Karyawan",
  pelanggan: "Pelanggan",
};
